import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from './UploadedOrdersFooter';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import useSortableData from './useSortableData';
import './UploadedOrders.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import axios from 'axios';
import Grid from '@mui/material/Grid';
import PropagateLoader from 'react-spinners/PropagateLoader';
import Backdrop from '@mui/material/Backdrop';
import MUIDataTable from 'mui-datatables';
import { socket, SocketContext } from '../../context/socket';
import { useSnackbar } from 'notistack';
import { SnackbarProvider } from 'notistack';
import DownLoadFile from './DownLoadFile';
import Countdown from 'react-countdown';
import TimeRemaining from './TimeRemaining';
import AuthContext from '../../auth/auth';
import React, {
  useState,
  useRef,
  useContext,
  Redirect,
  useEffect,
} from 'react';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import Button from '@mui/material/Button';
import SampleListView from '../List/SampleListView';

const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV;
<link href="path-to-react-table-filter/lib/styles.css" rel="stylesheet" />;
async function getInitialData({
  setGetLoad,
  setUploadedOrders,
  setOrderReceived,
  ordersReceived,
  user,
}) {
  if (ordersReceived === false) {
    //console.log("getInitialData run" + user.casUser);
    try {
      const res = await axios.get(
        API_ENDPOINT + '/clientOrders/uploadedOrders',
        {
          params: {
            username: user.casUser,
          },
        }
      );
      let dataToBeUsed = [];
      //console.log("res.data: " + res.data.length);
      res.data.forEach((element) => {
        let oneRow = {};
        Object.keys(element).forEach((el) => {
          if (el == '__v') {
          } else if (el == 'dateUploaded') {
            const timeRemaining =
              Date.now() +
              (86400000 - (Date.now() - new Date(element[el]).getTime()));
            oneRow = { ...oneRow, [el]: element[el] };
            console.log('timeRemaining: ' + timeRemaining);
          } else {
            console.log('key: ' + el + ': inital Data inside: ' + element[el]);
            oneRow = { ...oneRow, [el]: element[el] };
          }
        });
        dataToBeUsed = [...dataToBeUsed, oneRow];
      });

      setUploadedOrders(dataToBeUsed);
      setGetLoad(false);
      setOrderReceived(true);
    } catch (error) {
      console.log(error);
    }
  } else {
    //DO Nothing
  }
}
function UploadedOrders(props) {
  const [getLoad, setGetLoad] = useState(true);
  const [ordersReceived, setOrderReceived] = useState(false);
  const [uploadedOrders, setUploadedOrders] = useState([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [submitLoad, setSubmitLoad] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [submitResponse, setSubmitResponse] = useState(null);
  const [submitSucess, setSubmitSucess] = useState(true);
  const user = useContext(AuthContext);
  useEffect(() => {
    socket.on('updateOthersUploadedOrders', (msg) => {
      //console.log("run");
      setOrderReceived(false);
      enqueueSnackbar(msg, { variant: 'info' });
    });
  }, []);

  useEffect(() => {
    socket.on('updateSelfUploadedOrders', () => {
      //console.log("run");
      setOrderReceived(false);
    });
  }, []);

  useEffect(() => {
    socket.on('connect', () => console.log(socket.id));
    socket.on('connect_error', () => {
      setTimeout(() => socket.connect(), 5000);
    });
    socket.on('disconnect', () => console.log('Server disconnected'));
  }, []);

  useEffect(() => {
    //console.log("run");
    getInitialData({
      setGetLoad,
      setUploadedOrders,
      setOrderReceived,
      ordersReceived,
      user,
    }).catch(console.error);
  }, [ordersReceived]);

  const handleClose = () => {
    setSubmitStatus(false);
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const handleDelete = (dropOffCode) => {
    return async (event) => {
      setSubmitLoad(true);
      try {
        var res = await axios.delete(
          API_ENDPOINT + '/clientOrders/delete/all',
          { data: { dropOffCode: dropOffCode } }
        );

        var status = res.status;

        console.log('status' + status);
        if (status === 201) {
          socket.emit(
            'deleteUploadedOrders',
            dropOffCode,
            user.firstName,
            user.lastName
          );
          console.log('status == 201');
          setSubmitSucess(true);
          setSubmitResponse('Delete sucessfully!');
        }
      } catch {
        console.log('error');
        setSubmitSucess(false);
        setSubmitResponse(
          'Unsucessful! Please try again later or contact adminsitrator if problem persists'
        );
      }

      console.log('submit');

      setSubmitStatus(true);
      setSubmitLoad(false);
    };
  };

  // some code for the timer --> not sure yet
  const FIFTEEN_HOURS_IN_MIS = 15 * 60 * 60 * 1000;
  const NOW_IN_MS = new Date().getTime();
  const dateTimeAfterThreeDays = NOW_IN_MS + FIFTEEN_HOURS_IN_MIS;

  // code for the table
  const UploadedOrdersTable = (props) => {
    const { items, requestSort, sortConfig } = useSortableData(
      props.uploadedOrders
    );
    const getClassNamesFor = (dropOffCode) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === dropOffCode ? sortConfig.direction : undefined;
    };
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width="500">
              <button
                type="button"
                onClick={() => requestSort('dropOffCode')}
                className={getClassNamesFor('dropOffCode')}
              >
                Drop-Off Code
              </button>
            </TableCell>
            <TableCell width="400">
              <button
                type="button"
                onClick={() => requestSort('timer')}
                className={getClassNamesFor('timer')}
              >
                Timer
              </button>
            </TableCell>
            <TableCell width="300">
              <button
                type="button"
                onClick={() => requestSort('excelFile')}
                className={getClassNamesFor('excelFile')}
              >
                Sample Data
              </button>
            </TableCell>
            <TableCell width="300">
              <button
                type="button"
                onClick={() => requestSort('delete')}
                className={getClassNamesFor('delete')}
              >
                Delete
              </button>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow hover key={item._id}>
              <TableCell>{item.dropOffCode}</TableCell>
              <TableCell>
                <TimeRemaining dateUploaded={item.dateUploaded} />
              </TableCell>
              <TableCell>
                {console.log(item)}
                <SampleListView orderType={item.submissionType} dropOffCode={item.dropOffCode}/>
              </TableCell>
              <TableCell>
                <Button
                  variant="outlined"
                  onClick={handleDelete(item.dropOffCode)}
                >
                  {' '}
                  Delete
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };

  return (
    <>
      <Grid
        container
        direction="column"
        alignItems="center"
        spacing={0}
        margin={0}
      >
        <Backdrop
          sx={{ color: '#fff', zIndex: 1 }}
          open={submitStatus}
          onClick={handleClose}
        >
          {submitSucess ? (
            <Alert
              onClose={() => {
                setSubmitStatus(false);
              }}
              icon={<CheckIcon fontSize="inherit" />}
              severity="success"
            >
              {submitResponse}
            </Alert>
          ) : (
            <Alert
              onClose={() => {
                setSubmitStatus(false);
              }}
              severity="error"
            >
              {submitResponse}
            </Alert>
          )}
        </Backdrop>
      </Grid>
      <Box sx={{ width: '100%' }}>
        <Row></Row>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <TableContainer>
            <Toolbar
              sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
              }}
            >
              <Typography
                sx={{ flex: '1 1 100%' }}
                variant="h6"
                id="tableTitle"
                component="div"
              >
                Uploaded Orders
              </Typography>
            </Toolbar>
            <Row></Row>
            <Row>
              <Col>
                <UploadedOrdersTable
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  uploadedOrders={uploadedOrders}
                />
              </Col>
              {/* {maxUploadMessage()} */}
            </Row>
          </TableContainer>
        </Paper>
      </Box>
    </>
  );
}
export default UploadedOrders;
